import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarning,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import '../../../scss/Components/_modal.scss';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalSDelete(props) {
  const {
    siteModalDeleteString,
    siteMDSiteNameString,
    siteMDClientString,
    siteMDStreetNameString,
    siteMDAddressNumString,
    siteMDPCString,
    siteMDEDateString,
    modalYesString,
    modalNoString,
  } = useTranslationHook();

  var deleteSiteName = localStorage.getItem('siteNameToDelete');
  var deleteSiteAddressStreet = localStorage.getItem(
    'siteAddressStreetToDelete'
  );
  var deleteSiteAddressNum = localStorage.getItem('siteAddressNumToDelete');
  var deleteSiteAddressPC = localStorage.getItem('siteAddressPCToDelete');
  var deleteSiteBusiness = localStorage.getItem('siteBusinessToDelete');
  var deleteSiteCreatedDate = localStorage.getItem('siteCreatedDateToDelete');

  var deleteSiteId = localStorage.getItem('siteIdToDelete');

  function deleteSite() {
    customAxios
      .request({
        url: `${GlobalVariables.getURL()}deleteSite/${deleteSiteId}`,
        method: 'delete',
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then(
        (response) => {
          console.log(response.data);
          hideS();
        },
        (error) => {
          console.log(error);
          getToast({
            status: 'error',
            title: 'Error al eliminar sucursal. Vuelve a intentarlo.',
          });
        }
      );
  }

  function hideS() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Sucursal eliminada exitosamente en la base de datos.',
    });
    let endpoint = `${GlobalVariables.getURL()}listClientSites`;
    if (props.selectedClients.length > 0) {
      endpoint += `?id=${props.selectedClients}`;
    }
    props.getSites(endpoint);
  }

  function hideN() {
    props.onHide();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
          {siteModalDeleteString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="delete-info">
          <strong>{siteMDSiteNameString}:</strong> {deleteSiteName}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDClientString}:</strong> {deleteSiteBusiness}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDStreetNameString}:</strong> {deleteSiteAddressStreet}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDAddressNumString}:</strong> {deleteSiteAddressNum}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDPCString}:</strong> {deleteSiteAddressPC}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDEDateString}:</strong> {deleteSiteCreatedDate}
        </span>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="modal-button"
          onClick={() => {
            deleteSite();
          }}
        >
          <FontAwesomeIcon icon={faWarning} /> Si, quiero inactivar el sitio
        </button>
        <button
          className="modal-button no"
          onClick={() => {
            hideN();
          }}
        >
          <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalSDelete;
